//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';
import { IUrlRouterProvider } from 'angular-ui-router';

import {
  IPartialState,
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

// Sets default values for state data
function TwitterStateFactory(state: IPartialState) {
  const accessFn = state.data?.hasAccess ?? (() => true);
  const data = {
    title: 'X Account',
    navGroup: NavGroup.PUBLISHING,
    ...state.data,
    hasAccess: () =>
      hasAllFeatures(FeatureNames.Social, FeatureNames.SocialDashboards) &&
      accessFn(),
  };

  return StateFactory({
    ...state,
    data,
  });
}

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  urlRouterProvider.when(
    '/twitter-v2/schedule',
    '/twitter-v2/schedule/timeline',
  );
  urlRouterProvider.when(
    '/twitter-v2/schedule/post-details',
    '/schedule/scheduler',
  );
  urlRouterProvider.when('/twitter-v2/drafts', '/schedule/drafts');
}

export const states = {
  twitterV2: TwitterStateFactory({
    url: '/twitter-v2',
    template: componentNameToTemplate('twitterPageV2'),
    redirectTo: 'twitterV2.summary',
    resolve: {
      ...lazyLoadModule(
        'curalate.twitterV2',
        () => import('@twitterV2/TwitterV2App'),
      ),
    },
  }),
  'twitterV2.summary': TwitterStateFactory({
    url: '/summary',
    views: {
      'twitter-header': {
        template: `<twitter-summary-header></twitter-summary-header>`,
      },
      'twitter-content': {
        template: componentNameToTemplate('twitterSummary'),
      },
    },
  }),
  'twitterV2.engagement': TwitterStateFactory({
    url: '/engagement',
    views: {
      'twitter-header': {
        template: `<twitter-header title="Organic Post Engagement"></twitter-header>`,
      },
      'twitter-content': {
        template: componentNameToTemplate('twitterEngagement'),
      },
    },
  }),
  'twitterV2.audience': TwitterStateFactory({
    url: '/audience',
    views: {
      'twitter-header': {
        template: `<twitter-header title="Audience"></twitter-header>`,
      },
      'twitter-content': {
        template: componentNameToTemplate('twitterAudience'),
      },
    },
  }),
};
